import { UpdateReason } from 'APP/constants/scroll';
import Entities from 'STORE';

export interface IFocusMessageParams {
  groupId: string;
  messageId: string;
  isAnimated?: boolean;
  messageElementSelector?: string;
}

export function focusMessage({
  groupId,
  messageId,
  isAnimated = true,
  messageElementSelector,
}: IFocusMessageParams): void {
  const group = Entities.GroupsStore.getGroupById(groupId);
  if (!group) {
    return;
  }

  group.messagesStore.focusMessage(messageId);

  if (group.isActive) {
    Entities.ChatStore.setScrollChanged(UpdateReason.FocusMessage, {
      messageId: messageId,
      isAnimated,
      messageElementSelector,
    });
  }
}
